import { inject, Injectable } from '@angular/core';
import { Constante } from '../../constante';

@Injectable({
    providedIn: 'root'
})
export class SecurityService {

    static clearSessionData(): void {
        sessionStorage.removeItem(Constante.TOKEN_APP);
        sessionStorage.removeItem(Constante.PERFIL_USER);
        sessionStorage.removeItem(Constante.INFO_USER);
        sessionStorage.removeItem(Constante.MENU_USER);

        // sessionStorage.removeItem(Constante.TOKEN_APP);
        sessionStorage.clear();
        console.clear();
    }

    static setToken(token: string) {
        sessionStorage.setItem(Constante.TOKEN_APP, token);
    }

    static getToken(): string | null {
        let token = sessionStorage.getItem(Constante.TOKEN_APP);
        if (token && token.length > 0) {
            return token;
        } else {
            return null;
        }
    }
    // static goToLogin() {
    //     this.clearSessionData()
    // }
}
